import { useNavigate, useParams } from 'react-router-dom';
import { Loader, Table, Group, Button } from '@mantine/core';
import { useSelector } from 'react-redux';
import { AppState } from '../../client-redux/reducers';
import { Language } from '../../languages/languageHandler';
import Header from '../../components/util/header';
import { LoginState } from '../../client-redux/login/reducer';
import PaginationComponent from '../../components/pagination';
import { useState, useEffect, useRef } from 'react';
import { Distribuition, DistribuitionsResponse, fetchDistributionList } from '../../../libraries/distribuition-list';
import { useFitTableRows } from '../../components/util/fit-table-rows-hook';
import { IconPlus } from '@tabler/icons-react';
import './styles.scss';

function DistributionsList() {
  const navigate = useNavigate();

  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const loginInfo = useSelector<AppState, LoginState>(state => state.login);
  const controller = useRef(new AbortController()).current;
  const [loading, setLoading] = useState<boolean>(false);
  const {
    limit = 10,
    setLimit,
    tableRef
  } = useFitTableRows({
    bufferRows: 1,
    minHeightForDynamic: 400
  });
  const [initialLimitReady, setInitialLimitReady] = useState(false);
  const [offset, setOffset] = useState<number>(0);
  const [totalRowsResponse, setTotalRowsResponse] = useState<number | undefined>();
  const { id } = useParams<{ id: string }>();
  const [uidFilter /* setUidFilter */] = useState<number | undefined>(id ? Number(id) : undefined);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [message, setMessage] = useState<DistribuitionsResponse>();
  const [noResults, setNoResults] = useState<boolean>(false);

  const [searchTrigger, setSearchTrigger] = useState<boolean>(true);

  useEffect(() => {
    if (!initialLimitReady && limit !== undefined && limit !== null) {
      setInitialLimitReady(true);
      setSearchTrigger(true);
    }
  }, [limit, initialLimitReady]);

  useEffect(() => {
    if (!initialLimitReady) return;

    if (searchTrigger) {
      setLoading(true);
      getDistribuitionList();
      setOffset(0);
      setSearchTrigger(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTrigger, initialLimitReady]);

  /*   const onSearch = () => {
    setSearchTrigger(true);
    setOffset(0);
    setCurrentPage(1);
  }; */

  const getDistribuitionList = () => {
    if (!loginInfo.token) {
      return;
    }
    if (loading) {
      setNoResults(false);
      controller.abort();
    }
    setLoading(true);
    const shouldFetchTotalRows = offset === 0;

    fetchDistributionList(limit, offset, shouldFetchTotalRows, controller, uidFilter)
      .then(response => {
        if (response.statusOper.code === 0) {
          setMessage(response);
          if (shouldFetchTotalRows && typeof response.totalRows === 'number') {
            setTotalRowsResponse(response.totalRows);
          }
          setNoResults(false);
          setLoading(false);
        } else {
          setNoResults(true);
          setLoading(false);
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') {
        } else {
        }
      })
      .finally(() => setLoading(false));
  };

  const changePage = (page: number) => {
    const newOffset = (page - 1) * limit;
    setCurrentPage(page);
    setOffset(newOffset);
  };

  const resultsSelect = (newValue: number) => {
    const newLimit = Number(newValue);
    setLimit(newLimit);
    setCurrentPage(1);
    setOffset(0);
  };

  /*   const updateTableUID = (newUID: number) => {
    setCurrentPage(1);
    setOffset(0);
    setUidFilter(newUID);
  }; */

  useEffect(() => {
    if (!initialLimitReady) return;

    getDistribuitionList();
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, limit, uidFilter]);

  return (
    <div className="distributions-list">
      <Header pageTitle={lang.GLOBAL_DISTRIBUITIONS} />
      {/*       <FilterBar onSearch={onSearch} tableLoaded={getDistribuitionList} filterByIDUser={updateTableUID} />
       */}
      <Button radius="md" onClick={() => navigate(`/distribution/new/0`)}>
        <IconPlus stroke={2} />
      </Button>
      <Table.ScrollContainer minWidth={500} ref={tableRef}>
        <Table striped highlightOnHover verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{lang.PROCESSED_GLASS_ID}</Table.Th>
              <Table.Th>{lang.GLOBAL_EVENT}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {loading && !message && (
              <Table.Tr>
                <Table.Td colSpan={16}>
                  <Loader color="#016273" />
                </Table.Td>
              </Table.Tr>
            )}
            {noResults && !loading ? (
              <Table.Tr>
                <Table.Td colSpan={16} style={{ textAlign: 'center' }}>
                  {lang.GLOBAL_NO_RESULTS}
                </Table.Td>
              </Table.Tr>
            ) : (
              message?.list?.map((distribuition: Distribuition, index: number) => (
                <Table.Tr
                  key={index}
                  onClick={() => navigate(`/distribution/edit/${distribuition.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <Table.Td>{distribuition.id}</Table.Td>
                  <Table.Td>{`${distribuition.eventCode} - ${distribuition.eventDescription}`}</Table.Td>
                </Table.Tr>
              ))
            )}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      <Group>
        <PaginationComponent
          total={totalRowsResponse}
          itemsPerPage={limit}
          dynamicLimit={limit}
          currentPage={currentPage}
          onPageChange={changePage}
          onResultsChange={resultsSelect}
          offset={offset}
        />
      </Group>
    </div>
  );
}

export default DistributionsList;
